import React, { Component } from 'react';
import { Button, Form, Input, Radio, Segment, Header, Divider, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import 'react-widgets/dist/css/react-widgets.css';
import axios from 'axios';
import { fetchFaculties } from '../../Lookups/util';
import { checkOrganizationalUnitsPrivilege, formatListForDropdownOptions, getLeaseholderName } from '../util/util';
import { fetchLegalDocumentTypes } from '../Lookups/util';
class LeaseForm extends Component {
    constructor(props, context) {
        super(props, context);
        const lease = props.lease || {};
        this.state = {
            loading: true,
            saving: false,
            leaseholder: lease.leaseholder ? lease.leaseholder.id : null,
            organizationalUnit: lease.leaseholder ? lease.leaseholder.organizationalUnit.id : null,
            leaseSubject: lease.leaseSubject || '',
            purpose: lease.purpose || '',
            comment: lease.comment || '',
            startDate: lease.dateStart ? new Date(lease.dateStart) : null,
            endDate: lease.dateEnd ? new Date(lease.dateEnd) : null,
            startDatePicked: !!lease.dateStart,
            endDatePicked: !!lease.dateEnd,
            monthlyIncome: lease.incomePerMonth || '',
            documentType: lease.legalDocument && lease.legalDocument.legalDocumentType ? lease.legalDocument.legalDocumentType.id : null,
            documentDate: lease.legalDocument && lease.legalDocument.date ? new Date(lease.legalDocument.date) : null,
            documentNumber: lease.legalDocument ? lease.legalDocument.documentNumber || '' : '',
            documentComment: lease.legalDocument ? lease.legalDocument.comment || '' : '',
            errors: {}
        };
        this.sendLeaseRequest = this.sendLeaseRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLeaseholderChange = this.handleLeaseholderChange.bind(this);
        this.handleOrganizationalUnitChange = this.handleOrganizationalUnitChange.bind(this);
        this.handleDocumentTypeChange = this.handleDocumentTypeChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDocumentDateChange = this.handleDocumentDateChange.bind(this);
    }

    componentDidMount() {
        axios.all([
            axios.get('/assets/leaseholders/'),
            fetchLegalDocumentTypes(),
            fetchFaculties(),
        ])
            .then(axios.spread((leaseholdersRes, legalDocumentTypesRes, facultiesRes) => {
                const legalDocumentTypes = formatListForDropdownOptions(legalDocumentTypesRes.data);
                const organizationalUnits = formatListForDropdownOptions(facultiesRes.data);
                const leaseholders = leaseholdersRes.data.map(leaseholder => ({
                    ...leaseholder,
                    value: leaseholder.id,
                    key: leaseholder.id,
                    text: getLeaseholderName(leaseholder),
                }));
                this.setState({
                    leaseholders,
                    legalDocumentTypes,
                    organizationalUnits,
                    loading: false,
                });
            }))
            .catch(err => {
                toast('Došlo je do greške prilikom učitavanja podataka!');
                this.setState({ loading: false });
            });
    }

    sendLeaseRequest() {
        const isEditing = !!this.props.lease;
        const {
            leaseholder,
            leaseSubject,
            purpose,
            comment,
            startDate,
            endDate,
            monthlyIncome,
            documentType,
            documentDate,
            documentNumber,
            documentComment,
        } = this.state;

        const errors = {
            organizationalUnitError: checkOrganizationalUnitsPrivilege() && !this.state.organizationalUnit,
            leaseholderError: !leaseholder,
            endDateError: !endDate,
            startDateError: !startDate || (startDate && endDate && startDate > endDate),
            monthlyIncomeError: !monthlyIncome,
            documentTypeError: !documentType,
            documentDateError: !documentDate,
            documentNumberError: !documentNumber,
        };

        if (Object.values(errors)
            .some(error => error)) {
            this.setState({ errors });
            const missingLegalDocumentFields = errors.documentTypeError || errors.documentDateError || errors.documentNumberError;
            toast(missingLegalDocumentFields
                ? 'Potrebno je popuniti sva obavezna polja, uključujući podatke o pravnom dokumentu!'
                : 'Potrebno je popuniti sva obavezna polja!');
            return;
        }

        const lease = {
            ...(isEditing && { id: this.props.lease.id }),
            ...(isEditing && { optLock: this.props.lease.optLock }),
            leaseholder: { id: leaseholder },
            leaseSubject: leaseSubject,
            purpose: purpose,
            comment: comment,
            dateStart: startDate || null,
            dateEnd: endDate || null,
            incomePerMonth: monthlyIncome,
        };

        lease.legalDocument = {
            ...(isEditing && this.props.lease.legalDocument && { id: this.props.lease.legalDocument.id }),
            ...(isEditing && this.props.lease.legalDocument && { optLock: this.props.lease.legalDocument.optLock }),
            legalDocumentType: documentType ? { id: documentType } : null,
            date: documentDate || null,
            documentNumber: documentNumber,
            comment: documentComment || null,
        };

        const apiCall = isEditing
            ? axios.put('/assets/leases/', lease)
            : axios.post('/assets/leases/', lease);

        this.setState({ saving: true }, () => {
            apiCall
                .then(res => {
                    toast(isEditing ? 'Zakup je uspješno izmijenjen!' : 'Zakup je uspješno kreiran!');
                    this.setState({ saving: false });
                    if (this.props.onRefreshData) this.props.onRefreshData();
                    if (this.props.onCloseForm) this.props.onCloseForm();
                })
                .catch(err => {
                    this.setState({ saving: false });
                    toast('Došlo je do greške!');
                    console.log(err);
                });
        });
    }

    handleInputChange(event, { value }) {
        this.setState({
            [event.target.name]: value !== '' ? value : null,
        });
    }

    handleLeaseholderChange(event, { value }) {
        this.setState({
            leaseholder: value,
        });
    }

    handleOrganizationalUnitChange(event, { value }) {
        this.setState({
            organizationalUnit: value,
            leaseholder: null,
        });
    }

    handleDocumentTypeChange(event, { value }) {
        this.setState({
            documentType: value,
        });
    }

    handleStartDateChange(event) {
        if (!this.state.endDate || event <= this.state.endDate) {
            this.setState({
                startDate: event,
                startDatePicked: true
            });
        }
    }

    handleEndDateChange(event) {
        if (!this.state.startDate || event >= this.state.startDate) {
            this.setState({
                endDate: event,
                endDatePicked: true
            });
        }
    }

    handleDocumentDateChange(event) {
        this.setState({
            documentDate: event,
        });
    }

    render() {
        const isEditing = !!this.props.lease;
        const { saving } = this.state;
        const {
            leaseholders,
            legalDocumentTypes,
            organizationalUnits
        } = this.state;

        if (this.state.loading) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        let filteredLeaseholders = leaseholders;
        if (checkOrganizationalUnitsPrivilege() && this.state.organizationalUnit) {
            filteredLeaseholders = filteredLeaseholders.filter(leaseholder => leaseholder.organizationalUnit.id === this.state.organizationalUnit);
        }

        return (
            <Segment secondary clearing>
                <Form noValidate>
                    <Form.Group widths="equal">
                        {checkOrganizationalUnitsPrivilege() &&
                            <Form.Dropdown
                                clearable
                                label="Članica"
                                value={this.state.organizationalUnit}
                                options={organizationalUnits}
                                name="organizationalUnit"
                                placeholder="Izaberite članicu"
                                onChange={this.handleOrganizationalUnitChange}
                                search
                                fluid
                                required
                                selection
                                error={this.state.errors.organizationalUnitError}
                            />
                        }
                        <Form.Field
                            label="Predmet zakupa"
                            control={Input}
                            name="leaseSubject"
                            value={this.state.leaseSubject}
                            onChange={this.handleInputChange}
                            placeholder="Unesite predmet zakupa"
                        />
                        <Form.Dropdown
                            clearable
                            label="Zakupac"
                            value={this.state.leaseholder}
                            options={filteredLeaseholders}
                            name="leaseholder"
                            placeholder="Izaberite zakupca"
                            onChange={this.handleLeaseholderChange}
                            search
                            fluid
                            disabled={checkOrganizationalUnitsPrivilege() && !this.state.organizationalUnit}
                            required
                            selection
                            error={this.state.errors.leaseholderError}
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            label="Namjena"
                            control={Input}
                            name="purpose"
                            value={this.state.purpose}
                            onChange={this.handleInputChange}
                            placeholder="Unesite namjenu zakupa"
                        />
                        <Form.Field
                            label="Napomena"
                            control={Input}
                            name="comment"
                            value={this.state.comment}
                            onChange={this.handleInputChange}
                            placeholder="Unesite napomenu"
                        />
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            placeholder={'Unesite datum početka'}
                            control={DateTimePicker}
                            label="Datum početka"
                            format="D. M. YYYY."
                            time={false}
                            max={this.state.endDatePicked ? this.state.endDate : new Date(2099, 11, 31)}
                            onChange={this.handleStartDateChange}
                            value={this.state.startDate}
                            required
                            error={this.state.errors.startDateError}
                        />
                        <Form.Field
                            placeholder={'Unesite datum kraja'}
                            control={DateTimePicker}
                            label="Datum kraja"
                            format="D. M. YYYY."
                            time={false}
                            min={this.state.startDatePicked ? this.state.startDate : new Date(1900, 0, 1)}
                            onChange={this.handleEndDateChange}
                            value={this.state.endDate}
                            required
                            error={this.state.errors.endDateError}
                        />
                        <Form.Field
                            label="Mjesečni prihodi (BAM)"
                            type="number"
                            control={Input}
                            name="monthlyIncome"
                            value={this.state.monthlyIncome}
                            onChange={this.handleInputChange}
                            placeholder="Unesite mjesečna primanja"
                            required
                            error={this.state.errors.monthlyIncomeError}
                        />
                    </Form.Group>
                    <Divider/>
                    <Header as="h4">Podaci o pravnom dokumentu (obavezno)</Header>
                    <Form.Group widths="equal">
                        <Form.Dropdown
                            clearable
                            label="Tip dokumenta"
                            value={this.state.documentType}
                            options={legalDocumentTypes}
                            name="documentType"
                            placeholder="Izaberite tip dokumenta"
                            onChange={this.handleDocumentTypeChange}
                            search
                            fluid
                            selection
                            required
                            error={this.state.errors.documentTypeError}
                        />
                        <Form.Field
                            placeholder={'Unesite datum izdavanja dokumenta'}
                            control={DateTimePicker}
                            label="Datum izdavanja dokumenta"
                            format="D. M. YYYY."
                            time={false}
                            onChange={this.handleDocumentDateChange}
                            value={this.state.documentDate}
                            required
                            error={this.state.errors.documentDateError}
                        />
                        <Form.Field
                            label="Broj dokumenta"
                            control={Input}
                            name="documentNumber"
                            value={this.state.documentNumber}
                            onChange={this.handleInputChange}
                            placeholder="Unesite broj dokumenta"
                            required
                            error={this.state.errors.documentNumberError}
                        />
                        <Form.Field
                            label="Napomena"
                            control={Input}
                            name="documentComment"
                            value={this.state.documentComment}
                            onChange={this.handleInputChange}
                            placeholder="Unesite napomenu"
                        />
                    </Form.Group>
                    <Button floated="right" onClick={this.props.onCloseForm} basic color="blue"
                            disabled={saving}>Odustani</Button>
                    <Button floated="right" color="blue" loading={saving} disabled={saving}
                            onClick={this.sendLeaseRequest}>
                        {isEditing ? 'Izmijeni' : 'Sačuvaj'}
                    </Button>
                </Form>
            </Segment>
        );
    }
}

export default LeaseForm;



// WEBPACK FOOTER //
// ./src/views/Assets/Leases/LeaseForm.js